import { render, staticRenderFns } from "./AdvantageUpdate.vue?vue&type=template&id=63cc3302&"
import script from "./AdvantageUpdate.vue?vue&type=script&lang=js&"
export * from "./AdvantageUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports